export const environment = {
  production: true,
  name: 'ci',
  // Chiave generata in data 14/01/2025: valida sia per cittadino-test.plugandpay.it che per cittadino.plugandpay.it
  recaptcha: {
    siteKey: '6LcrM7cqAAAAANRnsmwiXMDc6fXlRz5Zb0K6sJje'
  },
  substringsToCheck: [
    'aux digit',
    'token non valido',
    // 'errore durante il pagamento presso digitpos'
  ],
  appInsights: {
    instrumentationKey: '797edf53-c689-464a-9107-a5f632f54c09'
  }
};
